import styled, { css } from 'styled-components';

export const icon = css`
  position: relative;
  margin-left: 9px;
  flex-shrink: 0;
`;

const mobilePaymentDescription = css<{
  isActive?: boolean;
}>`
  padding: 0;
  padding-right: 30px;
  margin-right: 0;
  font-size: 11px;
  line-height: 14px;
  white-space: normal;
`;

const desktopPaymentDescription = css<{
  isActive?: boolean;
}>`
  margin-right: 30px;
  margin-bottom: 5px;
  font-size: 14px;
`;

export const PaymentDescription = styled.p<{
  isActive?: boolean;
  isDisabled?: boolean;
  isMobile?: boolean;
}>`
  color: ${({ isActive, isDisabled, theme }) =>
    !isActive || isDisabled ? theme.colors.greyLight : theme.colors.blackBase};
  ${({ isMobile }) =>
    isMobile ? mobilePaymentDescription : desktopPaymentDescription}
`;
